import de from "../i18n/de/freigabe.json";
import en from "../i18n/en/freigabe.json";

function assignmentContext(error, catalog) {
  const context = error?.body || error;
  if (!Array.isArray(context?.currentTopics) || typeof context.includesUnassigned !== "boolean"
    || !context.currentTopics.every(topic => topic && typeof topic.id === "string" && topic.id.trim()
      && (topic.name === null || typeof topic.name === "string"))) return null;
  const topics = [...new Map(context.currentTopics.map(topic => [topic.id, topic])).values()];
  const labels = topics.map(topic => typeof topic.name === "string" && topic.name.trim()
    ? catalog.packageTopic.currentTopicName.replace("{{name}}", () => topic.name)
    : catalog.packageTopic.currentTopicUnnamed.replace("{{id}}", () => topic.id));
  if (context.includesUnassigned) labels.push(catalog.packageTopic.currentTopicUnassigned);
  if (!labels.length) return null;
  return catalog.packageTopic.assignmentConflict.replace("{{topics}}", () => labels.join(", "));
}

export function transportTopicError(error, language = typeof window !== "undefined" ? window.__iioLang || "de" : "de") {
  const code = typeof error === "string" ? error : error?.code || error?.body?.code;
  const catalog = String(language).toLowerCase().startsWith("en") ? en : de;
  const knownCode = Object.prototype.hasOwnProperty.call(catalog.topics.errors, code);
  if (!knownCode && !String(code || "").startsWith("TOPIC_")) return null;
  if (code === "TOPIC_PACKAGE_ENDPOINT_REQUIRED") {
    const message = assignmentContext(error, catalog);
    if (message) return message;
  }
  return catalog.topics.errors[code] || catalog.packageTopic.errors[code] || catalog.topics.writeError;
}
